/**
 * Step ↔ agent ↔ data-key mappings (ISO 21434 order).
 *
 * Extracted from WorkflowMachineContext.jsx during Story 4.6 wrap-up
 * to slim the residue. Pure functions — safe to import anywhere.
 */

// Helper function to get step number for agent
export const getStepForAgent = (agentName) => {
  // ISO 21434 order: Item Definition → Assets → Damage Scenarios → Threats → Attack Paths → Risk → Requirements
  const agentStepMap = {
    'analysis_agent': 1,
    'asset_identification_agent': 2,
    'damage_scenario_agent': 3,           // ISO 21434: Damage scenarios before threats
    'threat_analysis_agent': 4,            // ISO 21434: Threats after damage scenarios
    'attack_path_feasibility_agent': 5,
    'risk_assessment_agent': 6,
    'cybersecurity_goals_agent': 7,        // ISO 21434 Clause 9.4
    'cybersecurity_concept_agent': 8,      // ISO 21434 Clause 9.5
    'final_report_agent': 9,
    'control_implementation': 10           // Residual TARA: All phases
  };
  return agentStepMap[agentName] || 0;
};

// Helper function to get data key for each step
export const getStepDataKey = (step) => {
  // ISO 21434 order: Item Definition → Assets → Damage Scenarios → Threats → Attack Paths → Risk → Goals → Concept → Report
  const stepDataMap = {
    1: 'itemDefinition',
    2: 'assets',
    3: 'damageScenarios',         // ISO 21434: Damage scenarios before threats
    4: 'threats',                  // ISO 21434: Threats after damage scenarios
    5: 'attackPaths',
    6: 'risks',
    7: 'cybersecurityGoals',       // ISO 21434 Clause 9.4: Goals (+ Claims)
    8: 'cybersecurityRequirements', // ISO 21434 Clause 9.5: Controls & Requirements
    9: 'report',
    10: 'residualTARA'             // Residual TARA: All phases
  };
  return stepDataMap[step] || null;
};
